import { Component, input, computed, ChangeDetectionStrategy } from '@angular/core';
import { VideoWidget } from '../../../../interfaces/view-widget/video-widget';
import { IconComponent } from '@outlaw/icons';

@Component({
  selector: 'ol-video-preview-widget',
  templateUrl: './video-preview-widget.component.html',
  styleUrls: ['./video-preview-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class VideoPreviewWidgetComponent {
  widget = input.required<VideoWidget>();

  title = computed(() => this.widget().title || '');
  description = computed(() => this.widget().description || '');
  thumbnailUrl = computed(() => this.widget().thumbnailUrl || '');
  duration = computed(() => this.widget().duration || '');
  url = computed(() => this.widget().url || '');
}
